<template>
    <div class="user_nav_box">
      <img class="img_logo" src="../../assets/img/common/logo.png" alt="">
      <h3>{{userTitle}}</h3>
      <ul class="user_nav" v-if="navTF">
        <li :class="active== 1?'active':''" @click="goLogin()">首頁</li>
        <li :class="active== 2?'active':''" @click="goDeal()">交易中心</li>
        <li :class="active== 3?'active':''" @click="goAccount()">帳戶中心</li>
        <li :class="active== 4?'active':''" @click="goProduct()">産品中心</li>
        <li :class="active== 5?'active':''" @click="goData()">數據中心</li>
				<li :class="active== 6?'active':''" @click="goApplicationCore()">應用中心</li>
      </ul>
    </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'UserNav',
  data() {
    return {
      active: sessionStorage.active || 1,
      userTitle: "商家平台",
    }
  },
  components: {

  },
  methods: {
    goHome() {
      this.$router.push('/');
    },
    goLogin() {
      this.active = 1;
      sessionStorage.active = 1;
      sessionStorage.removeItem("dropActive");
      sessionStorage.removeItem("numberactive");
      this.$router.push('/login');
    },
    goDeal() {
      this.active = 2;
      sessionStorage.active = 2;
      sessionStorage.removeItem("dropActive");
      sessionStorage.removeItem("numberactive");
      this.$router.push('/login/deal');
    },
    goAccount() {
      this.active = 3;
      sessionStorage.active = 3;
      sessionStorage.removeItem("dropActive");
      sessionStorage.removeItem("numberactive");
      this.$router.push('/login/account');
    },
    goProduct(){
      this.active = 4;
      sessionStorage.active = 4;
      sessionStorage.removeItem("dropActive");
      sessionStorage.removeItem("numberactive");
			this.$router.push('/login/product');
    },
    goData(){
      this.active = 5;
      sessionStorage.active = 5;
      sessionStorage.removeItem("dropActive");
      sessionStorage.removeItem("numberactive");
      this.$router.push('/login/data');
    },
    goApplicationCore(){
      // localStorage.setItem("Baudit", "isBranch");
      let getBaudit = localStorage.getItem("Baudit");

      if(getBaudit == "isBranch"){
        // 休要走:
        this.$router.push("/login/loginaudit");
      } else {
        // 让你GO:
        var params = new URLSearchParams();
        params.append('username', localStorage.user);
        params.append('password', localStorage.pass);
        axios.post(this.$store.state.axiosGetUrl+'&b=1',params
              ).then((res) => {
                window.location.href = this.$store.state.axiosGetApplicationCoreUrl;
              })
        }
    },

  },
  computed: {
    navTF(){
      return this.$store.state.navTF
    },
  },
  mounted() {
    // console.log(this.$route);
    let rouUrl = this.$route.matched[1].path;

    // 首页：
    if(rouUrl == '/login/'){
      this.active = 1;
      sessionStorage.active = 1;
    }
    // 交易中心：
    if(rouUrl == '/login/deal'){
      this.active = 2;
      sessionStorage.active = 2;
    }
    // 账户中心：
    if(rouUrl == '/login/account'){
      this.active = 3;
      sessionStorage.active = 3;
    }
    // 产品中心：
    if(rouUrl == '/login/product'){
      this.active = 4;
      sessionStorage.active = 4;
    }
    // 数据中心：
    if(rouUrl == '/login/data'){
      this.active = 5;
      sessionStorage.active = 5;
    }

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .user_nav_box {
    margin: 28px;
    position: relative;
    overflow: hidden;
    color: black;
    font-size: 13px;
    min-width: 650px;
  }
  .user_nav_box h3 {
    float: left;
    line-height: 50px;
    font-size: 25px;
    font-weight: bold;
  }
  .user_nav_box img {
    float: left;
    cursor:pointer;
    margin-right: 20px;
    width: 112px;
    height: 50px;
  }
  .user_nav {
    float: right;
    overflow: hidden;
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .user_nav li {
     float: left;
     padding: 0 15px;
     cursor: pointer;
  }
	.user_nav li a{
	   color: black;
	}
  .user_nav li+li {
    border-left: 2px solid black;
    
  }
  .user_nav .active {
    color: #e73262;
    font-weight: bold;
  }
  /* 我是分割线
  .cut_off {
    height: 6px;
    color: #e73262;
  } */
</style>
